import { render, staticRenderFns } from "./TableUpload.vue?vue&type=template&id=b652a01e&"
import script from "./TableUpload.vue?vue&type=script&lang=js&"
export * from "./TableUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports